/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as DeploymentRouteImport } from './routes/deployment'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as GenerationsRouteImport } from './routes/generations'
import { Route as ImageAdsRouteImport } from './routes/image-ads'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as StartRouteImport } from './routes/start'
import { Route as StaticAdRouteImport } from './routes/static-ad'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as VideoAdRouteImport } from './routes/video-ad'
import { Route as VideoAdsRouteImport } from './routes/video-ads'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountHelpRouteImport } from './routes/account.help'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountSubscriptionRouteImport } from './routes/account.subscription'
import { Route as BrandsIndexRouteImport } from './routes/brands.index'
import { Route as BrandsBrandIdRouteImport } from './routes/brands.$brandId'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsProductIdRouteImport } from './routes/products.$productId'
import { Route as ScratchpadFeatureRouteImport } from './routes/scratchpad.$feature'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const DeploymentRoute = DeploymentRouteImport.update({
  id: '/deployment',
  path: '/deployment',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const GenerationsRoute = GenerationsRouteImport.update({
  id: '/generations',
  path: '/generations',
  getParentRoute: () => rootRouteImport,
} as any)
const ImageAdsRoute = ImageAdsRouteImport.update({
  id: '/image-ads',
  path: '/image-ads',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const StaticAdRoute = StaticAdRouteImport.update({
  id: '/static-ad',
  path: '/static-ad',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoAdRoute = VideoAdRouteImport.update({
  id: '/video-ad',
  path: '/video-ad',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoAdsRoute = VideoAdsRouteImport.update({
  id: '/video-ads',
  path: '/video-ads',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountHelpRoute = AccountHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AccountRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRoute,
} as any)
const AccountSubscriptionRoute = AccountSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => AccountRoute,
} as any)
const BrandsIndexRoute = BrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsBrandIdRoute = BrandsBrandIdRouteImport.update({
  id: '/brands/$brandId',
  path: '/brands/$brandId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const ScratchpadFeatureRoute = ScratchpadFeatureRouteImport.update({
  id: '/scratchpad/$feature',
  path: '/scratchpad/$feature',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/deployment': typeof DeploymentRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/generations': typeof GenerationsRoute
  '/image-ads': typeof ImageAdsRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/start': typeof StartRoute
  '/static-ad': typeof StaticAdRoute
  '/verify-email': typeof VerifyEmailRoute
  '/video-ad': typeof VideoAdRoute
  '/video-ads': typeof VideoAdsRoute
  '/welcome': typeof WelcomeRoute
  '/account/help': typeof AccountHelpRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/subscription': typeof AccountSubscriptionRoute
  '/brands/$brandId': typeof BrandsBrandIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/scratchpad/$feature': typeof ScratchpadFeatureRoute
  '/account/': typeof AccountIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/products/': typeof ProductsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/deployment': typeof DeploymentRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/generations': typeof GenerationsRoute
  '/image-ads': typeof ImageAdsRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/start': typeof StartRoute
  '/static-ad': typeof StaticAdRoute
  '/verify-email': typeof VerifyEmailRoute
  '/video-ad': typeof VideoAdRoute
  '/video-ads': typeof VideoAdsRoute
  '/welcome': typeof WelcomeRoute
  '/account/help': typeof AccountHelpRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/subscription': typeof AccountSubscriptionRoute
  '/brands/$brandId': typeof BrandsBrandIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/scratchpad/$feature': typeof ScratchpadFeatureRoute
  '/account': typeof AccountIndexRoute
  '/brands': typeof BrandsIndexRoute
  '/products': typeof ProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/deployment': typeof DeploymentRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/generations': typeof GenerationsRoute
  '/image-ads': typeof ImageAdsRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/start': typeof StartRoute
  '/static-ad': typeof StaticAdRoute
  '/verify-email': typeof VerifyEmailRoute
  '/video-ad': typeof VideoAdRoute
  '/video-ads': typeof VideoAdsRoute
  '/welcome': typeof WelcomeRoute
  '/account/help': typeof AccountHelpRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/subscription': typeof AccountSubscriptionRoute
  '/brands/$brandId': typeof BrandsBrandIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/scratchpad/$feature': typeof ScratchpadFeatureRoute
  '/account/': typeof AccountIndexRoute
  '/brands/': typeof BrandsIndexRoute
  '/products/': typeof ProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/deployment'
    | '/forgot-password'
    | '/generations'
    | '/image-ads'
    | '/login'
    | '/reset-password'
    | '/start'
    | '/static-ad'
    | '/verify-email'
    | '/video-ad'
    | '/video-ads'
    | '/welcome'
    | '/account/help'
    | '/account/profile'
    | '/account/subscription'
    | '/brands/$brandId'
    | '/products/$productId'
    | '/scratchpad/$feature'
    | '/account/'
    | '/brands/'
    | '/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/deployment'
    | '/forgot-password'
    | '/generations'
    | '/image-ads'
    | '/login'
    | '/reset-password'
    | '/start'
    | '/static-ad'
    | '/verify-email'
    | '/video-ad'
    | '/video-ads'
    | '/welcome'
    | '/account/help'
    | '/account/profile'
    | '/account/subscription'
    | '/brands/$brandId'
    | '/products/$productId'
    | '/scratchpad/$feature'
    | '/account'
    | '/brands'
    | '/products'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/deployment'
    | '/forgot-password'
    | '/generations'
    | '/image-ads'
    | '/login'
    | '/reset-password'
    | '/start'
    | '/static-ad'
    | '/verify-email'
    | '/video-ad'
    | '/video-ads'
    | '/welcome'
    | '/account/help'
    | '/account/profile'
    | '/account/subscription'
    | '/brands/$brandId'
    | '/products/$productId'
    | '/scratchpad/$feature'
    | '/account/'
    | '/brands/'
    | '/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  DeploymentRoute: typeof DeploymentRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GenerationsRoute: typeof GenerationsRoute
  ImageAdsRoute: typeof ImageAdsRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  StartRoute: typeof StartRoute
  StaticAdRoute: typeof StaticAdRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  VideoAdRoute: typeof VideoAdRoute
  VideoAdsRoute: typeof VideoAdsRoute
  WelcomeRoute: typeof WelcomeRoute
  BrandsBrandIdRoute: typeof BrandsBrandIdRoute
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ScratchpadFeatureRoute: typeof ScratchpadFeatureRoute
  BrandsIndexRoute: typeof BrandsIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deployment': {
      id: '/deployment'
      path: '/deployment'
      fullPath: '/deployment'
      preLoaderRoute: typeof DeploymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generations': {
      id: '/generations'
      path: '/generations'
      fullPath: '/generations'
      preLoaderRoute: typeof GenerationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/image-ads': {
      id: '/image-ads'
      path: '/image-ads'
      fullPath: '/image-ads'
      preLoaderRoute: typeof ImageAdsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static-ad': {
      id: '/static-ad'
      path: '/static-ad'
      fullPath: '/static-ad'
      preLoaderRoute: typeof StaticAdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video-ad': {
      id: '/video-ad'
      path: '/video-ad'
      fullPath: '/video-ad'
      preLoaderRoute: typeof VideoAdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video-ads': {
      id: '/video-ads'
      path: '/video-ads'
      fullPath: '/video-ads'
      preLoaderRoute: typeof VideoAdsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/help': {
      id: '/account/help'
      path: '/help'
      fullPath: '/account/help'
      preLoaderRoute: typeof AccountHelpRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/subscription': {
      id: '/account/subscription'
      path: '/subscription'
      fullPath: '/account/subscription'
      preLoaderRoute: typeof AccountSubscriptionRouteImport
      parentRoute: typeof AccountRoute
    }
    '/brands/': {
      id: '/brands/'
      path: '/brands'
      fullPath: '/brands/'
      preLoaderRoute: typeof BrandsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands/$brandId': {
      id: '/brands/$brandId'
      path: '/brands/$brandId'
      fullPath: '/brands/$brandId'
      preLoaderRoute: typeof BrandsBrandIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scratchpad/$feature': {
      id: '/scratchpad/$feature'
      path: '/scratchpad/$feature'
      fullPath: '/scratchpad/$feature'
      preLoaderRoute: typeof ScratchpadFeatureRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AccountRouteChildren {
  AccountHelpRoute: typeof AccountHelpRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountSubscriptionRoute: typeof AccountSubscriptionRoute
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountHelpRoute: AccountHelpRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountSubscriptionRoute: AccountSubscriptionRoute,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  DeploymentRoute: DeploymentRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GenerationsRoute: GenerationsRoute,
  ImageAdsRoute: ImageAdsRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  StartRoute: StartRoute,
  StaticAdRoute: StaticAdRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  VideoAdRoute: VideoAdRoute,
  VideoAdsRoute: VideoAdsRoute,
  WelcomeRoute: WelcomeRoute,
  BrandsBrandIdRoute: BrandsBrandIdRoute,
  ProductsProductIdRoute: ProductsProductIdRoute,
  ScratchpadFeatureRoute: ScratchpadFeatureRoute,
  BrandsIndexRoute: BrandsIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
